<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <!--<Select v-model="search.aduit_stats" style="width: 150px;" @on-change="loadData">-->
        <!--<Option :value="9">全部</Option>-->
        <!--<Option :value="2">已通过</Option>-->
        <!--<Option :value="1">待处理</Option>-->
      <!--</Select>-->
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'users',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      selectItems: [],
      sdkVersion: [],
      role: [
        { name: '超级管理员', val: 1 },
        { name: '管理员', val: 2 },
        { name: '普通用户', val: 3 }
      ],
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: 'userID',
          key: 'uid',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '用户名',
          key: 'username',
          minWidth: 200
        },
        {
          title: '手机号',
          key: 'mobile',
          align: 'center',
          minWidth: 150
        },
        {
          title: '用户状态',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let role = ''
            this.role.forEach(n => {
              if (params.row.role_id === n.val) role = n.name
            })
            return h('span', role)
          }
        },
        {
          title: '上次登录IP地址',
          key: 'ip',
          align: 'center',
          minWidth: 150
        },
        {
          title: '更新时间',
          key: 'updated_at',
          align: 'center',
          width: 200,
          render: (h, params) => {
            return h('span', utils.formatTime(params.row.updated_at))
          }
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: params.row.role_id === 1
                },
                style: {
                  width: '100px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.editData({
                      role_id: params.row.role_id === 3 ? 2 : 3,
                      uid: params.row.uid,
                      state: params.row.state
                    })
                  }
                }
              }, params.row.role_id === 3 ? '设为管理员' : '设为普通用户'),
              h('i-switch', {
                props: {
                  value: params.row.state === 1,
                  trueColor: '#13ce66',
                  disabled: params.row.role_id === 1
                },
                on: {
                  'on-change': (data) => {
                    this.editData({
                      role_id: params.row.role_id,
                      uid: params.row.uid,
                      state: data ? 1 : 2
                    })
                  }
                }
              }, '拒绝')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    loadData () {
      https.request({
        method: 'get',
        url: '/v1/jurisdiction/user'
      }).then(res => {
        this.tableLoading = false
        this.dataSource = res.data || []
        this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    editData (params) {
      https.request({
        method: 'post',
        url: '/v1/jurisdiction/user/do',
        data: params
      }).then(res => {
        this.$Message.success('设置成功')
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/users.vue